// 수행평가
import Resource from './Resource'

export default class Org extends Resource {
  static ENDPOINT = '/api/org'

  constructor (args) {
    super()
    this.extend(args)
  }

  static create (args) {
    return new Org(args)
  }
}
